import styled, { css } from 'styled-components';

export const Container = styled.div`
  padding: 24px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  display: inline-block;
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 37px;
  color: #0b29fb;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const Subtitle = styled.span`
  display: inline-block;
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #3d3d3d;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
`;

type TabsProps = {
  active?: boolean;
};

export const TabAll = styled.div<TabsProps>`
  cursor: pointer;
  padding: 12px 38px;
  border-bottom: 2px solid #d9d9d9;
  transition: border-bottom 0.3s;
  display: flex;
  align-items: center;
  gap: 10px;

  ${({ active }) =>
    active &&
    css`
      border-bottom: 2px solid #0b29fb;
    `}
`;

export const TabAllTitle = styled.span<TabsProps>`
  display: inline-block;
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;
  transition: color 0.3s;

  ${({ active }) =>
    active &&
    css`
      color: #0b29fb;
    `}
`;

export const FilterItemsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const TabsWrapper = styled.div`
  margin-top: 24px;
`;

export const TableWrapper = styled.div`
  margin-top: 24px;
`;

export const Count = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;
  padding: 3px 10px;
  border-radius: 16px;
  background: #d9d9d9;
`;
